export const APP_VERSION = 'admin-2026.09.01.193203';
export const APP_NAME = 'admin';
